<template>
  <q-dialog :model-value="modelValue" persistent @update:model-value="$emit('update:modelValue', $event)">
    <q-card style="min-width: 380px; max-width: 500px; border-radius: 14px;">
      <q-card-section class="row items-center q-pb-none">
        <q-icon name="warning" color="deep-orange-7" size="28px" class="q-mr-sm" />
        <span style="font-size: 15px; font-weight: 700; color: #2c3e50;">Завершить работу?</span>
        <q-space />
        <q-btn icon="close" flat round dense v-close-popup />
      </q-card-section>

      <q-card-section>
        <p style="font-size: 13px; color: #455a64; margin: 0 0 8px;">
          Выбранные работы <b>выполнены менее чем на 100%</b>.
        </p>
        <p style="font-size: 13px; color: #455a64; margin: 0;">
          Завершение при неполном выполнении приведёт к&nbsp;<b>уменьшению сметы</b>
          и&nbsp;формированию <b>дополнительного соглашения</b>. Продолжить?
        </p>
      </q-card-section>

      <q-card-actions align="right" class="q-pt-none q-pb-md q-px-md">
        <q-btn label="Отмена" flat no-caps color="grey-7" v-close-popup />
        <q-btn
          label="Завершить всё равно"
          unelevated no-caps
          color="deep-orange-7"
          :loading="loading"
          @click="$emit('confirm')"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'PpmCompleteDialog',
  props: {
    modelValue: Boolean,
    loading: Boolean,
  },
  emits: ['update:modelValue', 'confirm'],
};
</script>
